export * from './platform/default/youbora.constants';

/**
 * Attributes the Youbora engine accepts through `setCustomAttributes`.
 *
 * They are fed by the analytics middleware (per-event `setAttributes`) and by
 * `setInitialAttributes` (device/app/user).
 */
export const DEFAULT_ATTRIBUTES = [
  // Content (dynamic)
  'currentTime',
  'duration',
  'isLive',
  'title',
  'assetType',
  'errorCode',
  'errorMessage',
  'errorMetadata',
  'errorFatal',
  'videoBitrate',
  'videoThroughput',
  'videoRendition',
  'videoWidth',
  'videoHeight',
  'videoQuality',
  'contentType',
  'resource',
  'playerName',
  'playerVersion',
  // Per-content layout analytics block (the `analytics.youbora` slice)
  'newProgramAnalyticsConfiguration',
  // Identity / device / app (from setInitialAttributes)
  'userId',
  'appCustomer',
  'appPlatform',
  'appVersion',
  'deviceBrand',
  'deviceModel',
  'deviceVersion',
  // Ads
  'adId',
  'adTitle',
  'adCreativeId',
  'adDuration',
  'adBreakId',
  'adBitrate',
  'adWidth',
  'adHeight',
  'adResource',
  'adSkippable',
  'adPosition',
  'adGivenAds',
  'adExpectedAds',
  'adGivenBreaks',
  'adBreaksTime',
  'adErrorCode',
  'adErrorMessage',
  'adErrorFatal',
  'adErrorCreativeId',
  'adErrorResource',
  'adErrorMetadata',
];

/** Default key used to pick the per-content layout analytics slice. */
export const THIRD_PARTY_KEY = 'youbora';
